// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-club-request .title {
  color: #3E0D42;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0.5px;
  line-height: 18px;
}
.app-club-request .subtitle {
  color: #948D94;
  font-size: 12px;
  letter-spacing: 0.4px;
  line-height: 18px;
}
.app-club-request .attendees {
  color: #6B556C;
  font-size: 11px;
  font-weight: bold;
  letter-spacing: 0.69px;
  line-height: 22px;
}
.app-club-request .header-offset {
  margin-top: 22px;
}
.app-club-request .request-wrapper {
  border: 1px solid #EBE9EB;
  border-radius: 3px;
  margin: 0 0 1rem 0;
}
.app-club-request .request-wrapper .request-content {
  margin: 16px;
}
.app-club-request .request-wrapper .request-content .company-name {
  color: #3E0D42;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0.5px;
  line-height: 18px;
  border-bottom: 1px solid #F1F0F1;
  padding: 0 0 12px 0;
}
.app-club-request .request-wrapper .request-content .sections {
  margin: 8px 0 0 0;
}
.app-club-request .request-wrapper .request-content .section-name {
  color: #6B556C;
  font-size: 11px;
  letter-spacing: 0.46px;
  line-height: 16px;
}
.app-club-request .request-wrapper .request-content .section-attendee {
  color: #6B556C;
  font-size: 11px;
  font-weight: bold;
  letter-spacing: 0.46px;
  line-height: 16px;
}
.app-club-request .request-wrapper .request-content .notes-text {
  color: #605260;
  font-size: 12px;
  margin-right: 12px;
}
.app-club-request .request-wrapper .request-content .notes-title {
  color: #6B556C;
  font-size: 11px;
  font-weight: bold;
}
.app-club-request .request-wrapper .request-content .notes-date {
  color: #948D94;
  font-size: 11px;
  border-top: 1px solid #EBE9EB;
  float: right;
  margin-bottom: 16px;
}
.app-club-request .request-wrapper .request-content .notes-area {
  min-height: 100px;
  margin-bottom: 16px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/club-interview-details/requests-view-club/requests-view-club.component.scss"],"names":[],"mappings":"AACI;EACI,cAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;AAAR;AAEI;EACI,cAAA;EACA,eAAA;EACA,qBAAA;EACA,iBAAA;AAAR;AAEI;EACI,cAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,iBAAA;AAAR;AAEI;EACI,gBAAA;AAAR;AAEI;EACI,yBAAA;EACA,kBAAA;EACA,kBAAA;AAAR;AACQ;EACI,YAAA;AACZ;AAAY;EACI,cAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,gCAAA;EACA,mBAAA;AAEhB;AAAY;EACI,iBAAA;AAEhB;AAAY;EACI,cAAA;EACA,eAAA;EACA,sBAAA;EACA,iBAAA;AAEhB;AAAY;EACI,cAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,iBAAA;AAEhB;AAAY;EACI,cAAA;EACA,eAAA;EACA,kBAAA;AAEhB;AAAY;EACI,cAAA;EACA,eAAA;EACA,iBAAA;AAEhB;AAAY;EACI,cAAA;EACA,eAAA;EACA,6BAAA;EACA,YAAA;EACA,mBAAA;AAEhB;AAAY;EACI,iBAAA;EACA,mBAAA;AAEhB","sourcesContent":[".app-club-request {\n    .title {\n        color: #3E0D42;\n        font-size: 14px;\n        font-weight: bold;\n        letter-spacing: 0.5px;\n        line-height: 18px;\n    }\n    .subtitle {\n        color: #948D94;\n        font-size: 12px;\n        letter-spacing: 0.4px;\n        line-height: 18px;\n    }\n    .attendees {\n        color: #6B556C;\n        font-size: 11px;\n        font-weight: bold;\n        letter-spacing: 0.69px;\n        line-height: 22px;\n    }\n    .header-offset {\n        margin-top: 22px;\n    }\n    .request-wrapper {\n        border: 1px solid #EBE9EB;\n        border-radius: 3px;\n        margin: 0 0 1rem 0;\n        .request-content {\n            margin: 16px;\n            .company-name {\n                color: #3E0D42;\n                font-size: 14px;\n                font-weight: bold;\n                letter-spacing: 0.5px;\n                line-height: 18px;\n                border-bottom: 1px solid #F1F0F1;\n                padding: 0 0 12px 0;\n            }\n            .sections {\n                margin: 8px 0 0 0;\n            }\n            .section-name {\n                color: #6B556C;\n                font-size: 11px;\n                letter-spacing: 0.46px;\n                line-height: 16px;\n            }\n            .section-attendee {\n                color: #6B556C;\n                font-size: 11px;\n                font-weight: bold;\n                letter-spacing: 0.46px;\n                line-height: 16px;\n            }\n            .notes-text {\n                color: #605260;\n                font-size: 12px;\n                margin-right: 12px;\n            }\n            .notes-title {\n                color: #6B556C;\n                font-size: 11px;\n                font-weight: bold;\n            }\n            .notes-date {\n                color: #948D94;\n                font-size: 11px;\n                border-top: 1px solid #EBE9EB;\n                float: right;\n                margin-bottom: 16px;\n            }\n            .notes-area {\n                min-height: 100px;\n                margin-bottom: 16px;\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
